import React, { useEffect, useState } from "react";
import { sendAPIRequest } from "helpers";
import DropdownField from "modules/pvs_activities/components/core/DropdownField";
import SiteLoader from "pages/components/SiteLoader";
import { useLocation } from "react-router-dom";

// Questions Options
const optionsQ1 = [
    { value: 'very_clear', label: 'Very clear' },
    { value: 'somewhat_clear', label: 'Somewhat clear' },
    { value: 'neutral', label: 'Neutral' },
    { value: 'somewhat_unclear', label: 'Somewhat unclear' },
    { value: 'very_unclear', label: 'Very unclear' },
];

const optionsQ2 = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
    { value: 'in_progress', label: 'In progress' },
];

const optionsQ3 = [
    { value: 'fully_implemented', label: 'The recommendation has been fully implemented' },
    { value: 'partially_implemented', label: 'The recommendation has been partially implemented' },
    { value: 'not_implemented', label: 'The recommendation has NOT been implemented' },
    { value: 'planning_to_implement', label: 'Planning to implement' },
    { value: 'dont_know', label: "I don't know" },
];

const optionsQ4 = [
    { value: '3_months', label: 'Within 3 months' },
    { value: '6_months', label: 'Within 6 months' },
    { value: '1_year', label: 'Within 1 year' },
    { value: 'not_started', label: 'Not yet started' },
];

const overallOptionsA = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
    { value: "dont_know", label: "I don't know" },
];

const overallOptionsB = [
    { value: 'improved', label: 'Improved' },
    { value: 'no_change', label: 'No change observed' },
    { value: 'degraded', label: 'Degraded' },
    { value: 'dont_know_na', label: "I don't know N/A" },
];

const overallOptionsC = [
    { value: 'all', label: 'All of our performance improvements are thanks to the recommendations made in our latest PVS Evaluation' },
    { value: 'most', label: 'Most of our performance improvements are thanks to the recommendations made in our latest PVS Evaluation' },
    { value: 'some', label: 'Some of our performance improvements are thanks to the recommendations made in our latest PVS Evaluation' },
    { value: 'none', label: 'None of our performance improvements are thanks to the recommendations made in our latest PVS Evaluation' },
];

const overallOptionsD = [
    { value: 'all', label: 'We will act on all of the recommendations' },
    { value: 'most', label: "We will act on most of the PVS activity's recommendations" },
    { value: 'half', label: 'We will act on half of the PVS activity’s recommendations' },
    { value: 'less_than_half', label: 'We will act on less than half of the PVS activity’s recommendations' },
];

const ActionTakenPerCC = () => {
    const [selectedTab, setSelectedTab] = useState("");
    const [responses, setResponses] = useState({});
    const [overallResponses, setOverallResponses] = useState({});
    const [surveyData, setSurveyData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        getSurveyData();
    }, []);
    const location = useLocation();
    const surveyMissionId = location.state?.surveyMissionId;
    const getSurveyData = async () => {
        try {
            setIsLoading(true);
            setError(null);
            const data = await sendAPIRequest(`/api/pvsa/survey/survey-data?id=${surveyMissionId}`);
            const response = await data.json();

            if (response.success) {
                setSurveyData(response.data);
            } else {
                setError("Failed to load survey data.");
            }
        } catch (error) {
            console.error("Error fetching survey data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (Array.isArray(surveyData) && surveyData.length > 0) {
            const firstValidCompetency = surveyData.find(cc => cc.competency_edition);
            if (firstValidCompetency) {
                setSelectedTab(firstValidCompetency.competency_edition);
            }
        }
    }, [surveyData]);

    const handleOnChange = (recId, questionKey, val) => {
        setResponses(prev => ({
            ...prev,
            [recId]: {
                ...prev[recId],
                [questionKey]: val
            }
        }));
    };

    const handleOverallChange = (key, value) => {
        setOverallResponses(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    return (
        <>{isLoading ? (
            <div className="card-body p-4">
                <SiteLoader position="relative" background="transparent" />
            </div>
        ) : (
            <div className="container-fluid mt-4">
                <div className="row">
                    <div className="col-md-4 col-lg-3 mb-3 d-flex flex-column overflow-auto list-group p-3 bg-light-orange" style={{ height: "100vh" }}>
                        <h3 className="mb-3">Critical Competencies</h3>
                        <div className="fs-5">
                            {surveyData.map((cc, ccIdx) => (
                                <div
                                    key={cc.cc_id || ccIdx}
                                    className={`p-2 rounded mb-2 w-100 text-start ${selectedTab === cc.competency_edition ? "bg-primary text-white" : ""}`}
                                    onClick={() => cc.competency_edition && setSelectedTab(cc.competency_edition)}
                                    aria-selected={selectedTab === cc.competency_edition}
                                    disabled={!cc.competency_edition}
                                >
                                    {cc.competency_edition || "Unnamed Competency"}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-md-8 col-lg-9 ps-6 mt-4">
                        <h3 className="mb-3">{selectedTab}</h3>
                        {surveyData && selectedTab ? (
                            surveyData
                                ?.find(cc => cc.competency_edition === selectedTab)
                                ?.recommendations?.map((rec, recIndex) => (
                                    <div key={recIndex} className="mb-4">
                                        <div className="mb-3 fs-5">
                                            <strong>Recommendation:</strong> {rec.Text}
                                        </div>
                                        {/* Recommendation Questions */}
                                        <div className="mb-4">
                                            <p className="fs-6 mb-2">How clear is the recommendation?</p>
                                            <DropdownField
                                                label="Select Option"
                                                plain={true}
                                                hasOptions={true}
                                                options={optionsQ1}
                                                value={responses[rec.id]?.question1 || null}
                                                onChange={(val) => handleOnChange(rec.id, 'question1', val)}
                                            />
                                        </div>
                                        <div className="mb-4">
                                            <p className="fs-6 mb-2">Have the Animal Health Services taken any actions based on the recommendation?</p>
                                            <DropdownField
                                                label="Select Option"
                                                plain={true}
                                                hasOptions={true}
                                                options={optionsQ2}
                                                value={responses[rec.id]?.question2 || null}
                                                onChange={(val) => handleOnChange(rec.id, 'question2', val)}
                                            />
                                        </div>
                                        <div className="mb-4">
                                            <p className="fs-6 mb-2">What is the status of actions taken on this recommendation?</p>
                                            <DropdownField
                                                label="Select Option"
                                                plain={true}
                                                hasOptions={true}
                                                options={optionsQ3}
                                                value={responses[rec.id]?.question3 || null}
                                                onChange={(val) => handleOnChange(rec.id, 'question3', val)}
                                            />
                                        </div>
                                        <div className="mb-4">
                                            <p className="fs-6 mb-2">How soon after receiving the recommendation did you begin taking action?</p>
                                            <DropdownField
                                                label="Select Option"
                                                plain={true}
                                                hasOptions={true}
                                                options={optionsQ4}
                                                value={responses[rec.id]?.question4 || null}
                                                onChange={(val) => handleOnChange(rec.id, 'question4', val)}
                                            />
                                        </div>
                                        <div className="mb-4">
                                            <p className="fs-6 mb-2">Do you have any additional comments regarding the recommendation?</p>
                                            <textarea className="form-control" rows="3" placeholder="Type here..." disabled></textarea>
                                        </div>
                                        <hr className="fw-bold" />
                                    </div>
                                )) || <div>No recommendations available for this competency.</div>
                        ) : (
                            <div>Please select a competency.</div>
                        )}

                        {/* Overall Questions */}
                        <div className="mt-5">
                            <h4>Overall Impact and Resources, by Critical Competency</h4>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">Were additional resources needed to implement the recommendations made for this Critical Competency?</p>
                                <DropdownField
                                    label="Select Option"
                                    plain={true}
                                    hasOptions={true}
                                    options={overallOptionsA}
                                    value={overallResponses['overallQ1'] || ""}
                                    onChange={(val) => handleOverallChange('overallQ1', val)}
                                />
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">Did you obtain additional resources to implement the recommendations made for this Critical Competency?</p>
                                <DropdownField
                                    label="Select Option"
                                    plain={true}
                                    hasOptions={true}
                                    options={overallOptionsA}
                                    value={overallResponses['overallQ2'] || ""}
                                    onChange={(val) => handleOverallChange('overallQ2', val)}
                                />
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">Did you have access to sufficient resources (e.g., time, budget, personnel) to act on the recommendations made for this Critical Competency?</p>
                                <DropdownField
                                    label="Select Option"
                                    plain={true}
                                    hasOptions={true}
                                    options={overallOptionsA}
                                    value={overallResponses['overallQ3'] || ""}
                                    onChange={(val) => handleOverallChange('overallQ3', val)}
                                />
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">Did you receive any support from external partners (e.g. financial or technical partners outside of your government) to help implement the recommendations made for this Critical Competency?</p>
                                <DropdownField
                                    label="Select Option"
                                    plain={true}
                                    hasOptions={true}
                                    options={overallOptionsA}
                                    value={overallResponses['overallQ4'] || ""}
                                    onChange={(val) => handleOverallChange('overallQ4', val)}
                                />
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">Are there any other actions related to this Critical Competency you would like to tell us about?</p>
                                <textarea className="form-control" rows="3" placeholder="Type here..." disabled></textarea>
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">How would you assess changes in capacity of your country's animal health services related to this Critical Competency since its last PVS Evaluation?</p>
                                <DropdownField
                                    label="Select Option"
                                    plain={true}
                                    hasOptions={true}
                                    options={overallOptionsB}
                                    value={overallResponses['overallQ6'] || ""}
                                    onChange={(val) => handleOverallChange('overallQ6', val)}
                                />
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">How much do you attribute any improvements in this Critical Competency to the recommendations made in your country's latest PVS Evaluation?</p>
                                <DropdownField
                                    label="Select Option"
                                    plain={true}
                                    hasOptions={true}
                                    options={overallOptionsC}
                                    value={overallResponses['overallQ7'] || ""}
                                    onChange={(val) => handleOverallChange('overallQ7', val)}
                                />
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">Overall, how confident are you that you will act on all of the PVS recommendations made for this Critical Competency?</p>
                                <DropdownField
                                    label="Select Option"
                                    plain={true}
                                    hasOptions={true}
                                    options={overallOptionsD}
                                    value={overallResponses['overallQ8'] || ""}
                                    onChange={(val) => handleOverallChange('overallQ8', val)}
                                />
                            </div>
                            <div className="mb-4">
                                <p className="fs-6 mb-2">What could have been done to make the recommendations made for this Critical Competency easier to act upon?</p>
                                <textarea className="form-control" rows="3" placeholder="Type here..." disabled></textarea>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    );
};

export default ActionTakenPerCC;